import {
  LOAD_TOOLS,
  LOAD_TOOLS_FAILURE,
  LOAD_TOOLS_SUCCESS,
  ToolActionTypes,
  ToolState,
} from "./types";

const initialState: ToolState = {
  tools: [],
  loading: false,
  error: "",
};

export const toolReducer = (
  state = initialState,
  action: ToolActionTypes
): ToolState => {
  switch (action.type) {
    case LOAD_TOOLS:
      return { ...state, loading: true };

    case LOAD_TOOLS_SUCCESS:
      return { ...state, loading: false, tools: action.payload };

    case LOAD_TOOLS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
